export default "__VITE_ASSET__Bn1xq353__"